module.exports = __webpack_public_path__ + "img/logo.a83b2b6a.png";